export const testimonials = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    location: 'Córdoba',
    role: 'Profe de E. Funcional',
    text: 'Organicé todo el año en una tarde. Nunca más llegué al lunes sin saber qué dar.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    role: 'Profe de Entrenamiento Funcional',
    text: 'Mis alumnos empezaron a ver su progreso semana a semana. El cambio fue enorme.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Profe de E. Funcional',
    text: 'El Tomo 5 solo ya vale cada peso. Dejé de improvisar por completo.',
  },
]

export const moreTestimonials = [
  {
    initials: 'CR',
    name: 'Cecilia Ruiz',
    age: 34,
    location: 'Mendoza',
    role: 'Profe de E. Funcional · 8 años de experiencia',
    text: 'En una sola tarde dejé organizado todo el año. Recuperé mis domingos.',
  },
  {
    initials: 'RM',
    name: 'Roberto Méndez',
    age: 41,
    location: 'Buenos Aires',
    role: 'Profe + Dueño de Box · 12 años en la profesión',
    text: 'El Método Profe Empresario me estabilizó la facturación. Ya no tengo meses flojos.',
  },
  {
    initials: 'SC',
    name: 'Sofía Cabrera',
    age: 28,
    location: 'La Plata',
    role: 'Profe de E. Funcional · 4 años de experiencia',
    text: 'Por primera vez pude mostrar progreso con números reales y gané autoridad.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Adaptación Funcional',
    months: 'Meses 1-2',
    content:
      'Base técnica, movilidad, activación, patrones funcionales y tests iniciales.',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Fuerza Metabólica',
    months: 'Meses 3-4',
    content: 'Progresión de fuerza aplicada a clases funcionales reales.',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Potencia y CORE',
    months: 'Meses 5-6',
    content: 'Explosividad, estabilidad, coordinación y transferencia.',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'Hipertrofia Funcional',
    months: 'Meses 7-8',
    content: 'Volumen, tensión y planificación inteligente.',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Resistencia de Élite',
    months: 'Meses 9-10',
    content: 'AMRAP, circuitos, bloques metabólicos y resistencia real.',
    icon: '📓',
  },
  {
    id: 'T6',
    name: 'Peak Performance & Recuperación',
    months: 'Meses 11-12',
    content: 'Consolidación, rendimiento y cierre anual con criterio.',
    icon: '📔',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '🗺️',
    name: 'Mapa Anual de Clases Cero Estrés',
    desc: 'Ordená los 6 tomos por mes, objetivo y progresión en 10 minutos.',
    value: '$8.000',
  },
  {
    id: '02',
    icon: '🎤',
    name: '52 Aperturas de Clase que te Hacen Quedar como Pro',
    desc: 'Scripts listos para empezar cada clase con autoridad.',
    value: '$10.000',
  },
  {
    id: '03',
    icon: '✅',
    name: 'Checklist Express Pre-Clase y Post-Clase',
    desc: 'Entrá a cada clase con todo bajo control.',
    value: '$9.000',
  },
  {
    id: '04',
    icon: '🔄',
    name: '101 Reemplazos Inteligentes de Ejercicios',
    desc: 'Resolvé al instante si falta material, espacio o cambia el grupo.',
    value: '$8.000',
  },
  {
    id: '05',
    icon: '🎯',
    name: 'Banco de Cierres de Clase y Frases de Retención',
    desc: 'Cerrá con impacto para que el alumno quiera volver.',
    value: '$9.000',
  },
  {
    id: '06',
    icon: '🖨️',
    name: 'Kit de Impresión Rápida para Llevar a Clase',
    desc: 'Fichas, tarjetas y planillas listas para imprimir.',
    value: '$9.000',
  },
]

export const faqs = [
  {
    q: '¿Sirve para plaza, gimnasio o box?',
    a: 'Sí. El sistema está pensado para contextos reales y material estándar.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Recibís acceso digital en PDF, listo para descargar en menos de 5 minutos después del pago.',
  },
  {
    q: '¿Funciona si recién empiezo como profe?',
    a: 'Sí. Te da estructura y claridad desde el principio. El Tomo 1 arranca desde la base técnica.',
  },
  {
    q: '¿Y si tengo grupos con distintos niveles?',
    a: 'Cada tomo incluye progresiones y regresiones por nivel para que adaptes cada clase a tu grupo real.',
  },
  {
    q: '¿Sirve si doy personalizadas (one-to-one)?',
    a: 'Sí, podés adaptarlo perfectamente. Muchos profes lo usan como base para sus PT.',
  },
  {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Mercado Pago, tarjeta de crédito y débito, transferencia y medios disponibles al momento del checkout.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días de garantía total, devolución del 100%, sin formularios ni preguntas.',
  },
]

export const purchaseNotifications = [
  { name: 'Mariela G.', city: 'Córdoba', plan: 'Combo Completo' },
  { name: 'Roberto M.', city: 'Buenos Aires', plan: 'Combo + Negocio' },
  { name: 'Laura P.', city: 'Rosario', plan: 'Combo Completo' },
  { name: 'Sofía C.', city: 'La Plata', plan: 'Combo + Negocio' },
  { name: 'Pablo A.', city: 'Neuquén', plan: 'Combo Completo' },
  { name: 'Cecilia R.', city: 'Mendoza', plan: 'Combo + Negocio' },
  { name: 'Verónica M.', city: 'Salta', plan: 'Combo Completo' },
  { name: 'Diego F.', city: 'Tucumán', plan: 'Combo + Negocio' },
  { name: 'Andrea L.', city: 'Mar del Plata', plan: 'Combo Completo' },
  { name: 'Martín S.', city: 'Bahía Blanca', plan: 'Combo + Negocio' },
]
